export default "__VITE_ASSET__BVg61lg8__"